const { Dialog, DialogContent, DialogActions, Button, Box } = require("@material-ui/core")
const { ErrorOutline, CheckCircleOutline, WarningAmber } = require("@material-ui/icons");

const DialogUI = ({ message, onClose, type = "success", buttonTitle = 'Aceptar' }) => {

    const config = {
        success: {
            color: "#2e7d32",
            Icon: CheckCircleOutline
        },
        error: {
            color: "#c62828",
            Icon: ErrorOutline
        },
        warning: {
            color: "#ed6c02",
            Icon: WarningAmber
        }
    };

    const { color, Icon } = config[type] || config.success;

    return(
        <Dialog
            open={Boolean(message)}
            onClose={onClose}
            disableEscapeKeyDown
        >
            <DialogContent style={{ maxWidth: 500 }}>
                <Box display="flex" alignItems="center" gap={10}>
                    <Icon style={{ fontSize: 40, color }} />
                    <span>{message}</span>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={()=> onClose("")}
                    style={{ color }}
                >
                    {buttonTitle}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogUI